import { styled, Grid, Button } from '@mui/material'

export const StyledGridControl = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(2.5),
}))

export const StyledGridInnerControl = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down('xs')]: {
    maxWidth: '100%',
    flex: '0 0 100%',
  },
}))

export const StyledButton = styled(Button)(({ theme }) => ({
  minWidth: 160,
  [theme.breakpoints.down('xs')]: {
    minWidth: '100%',
  },
}))
